import { ReactNode } from 'react';
import { Text, Colors } from '@mercator-gcp/grout';

const labelStyle = {
  padding: 'padding_8',
  paddingTop: 'padding_24',
};

type TSectionProps = {
  title: string;
  children: ReactNode;
};

const Section = ({ title, children }: TSectionProps) => {
  return (
    <>
      <Text.SmallLabel as="div" color={Colors.TextQuiet} sx={labelStyle}>
        {title}
      </Text.SmallLabel>
      {children}
    </>
  );
};

export default Section;
